import { useEffect, useState } from "react";
import { brand, navLinks } from "@/mocks/site";
import { buildWhatsAppLink } from "@/utils/links";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        solid
          ? "border-b border-secondary-200 bg-background-50/95 backdrop-blur-md"
          : "border-b border-transparent bg-background-50"
      }`}
    >
      <div className="w-full px-5 md:px-10">
        <div className="flex h-[68px] items-center justify-between gap-6 md:h-[80px]">
          <a
            href="#inicio"
            onClick={() => setOpen(false)}
            className="flex items-center gap-3 text-foreground-950"
          >
            <span className="relative flex items-center">
              <img
                src="https://public.readdy.ai/ai/img_res/sandbox/9cb12466a7ca8578d3f0c1264f976445/9840a650-a9a9-4eeb-b115-77e1b33949e2_alea-logo.png"
                alt="ALÉA Aesthetic House"
                title="ALÉA Aesthetic House — Estética clínica en Culiacán"
                className="h-[22px] w-auto md:h-[26px]"
              />
            </span>
            <span className="hidden h-4 w-px bg-secondary-300 sm:block" />
            <span className="hidden font-label text-[10px] uppercase tracking-[0.22em] text-foreground-500 sm:block">
              Aesthetic House
            </span>
          </a>

          <nav className="hidden items-center gap-6 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="nav-underline whitespace-nowrap font-label text-[11px] font-medium uppercase tracking-[0.14em] text-foreground-600 transition-colors duration-300 hover:text-foreground-950"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={buildWhatsAppLink("Hola ALÉA, quiero agendar una valoración.")}
              target="_blank"
              rel="noreferrer"
              className="cta-primary hidden min-h-[44px] items-center whitespace-nowrap rounded-[14px] bg-primary-500 px-5 font-label text-[11px] font-semibold uppercase tracking-[0.12em] text-background-50 transition-all duration-300 hover:bg-primary-600 md:inline-flex"
            >
              Agendar valoración
            </a>

            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="Abrir menú"
              className="flex h-10 w-10 items-center justify-center rounded-[14px] border border-secondary-300 text-foreground-900 transition-colors duration-300 hover:border-primary-500 lg:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      <div
        className={`overflow-hidden border-t border-secondary-200 bg-background-50 transition-[max-height] duration-500 lg:hidden ${
          open ? "max-h-[560px]" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-5 py-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="border-b border-secondary-200 py-3.5 font-heading text-lg font-semibold text-foreground-900 transition-colors hover:text-accent-700"
            >
              {link.label}
            </a>
          ))}
          <a
            href={buildWhatsAppLink("Hola ALÉA, quiero agendar una valoración.")}
            target="_blank"
            rel="noreferrer"
            className="cta-primary mt-5 inline-flex min-h-[48px] items-center justify-center whitespace-nowrap rounded-[16px] bg-primary-500 px-6 font-label text-[11px] font-semibold uppercase tracking-[0.12em] text-background-50"
          >
            Agendar valoración
          </a>
          <span className="mt-4 pb-2 text-center font-label text-[10px] uppercase tracking-[0.22em] text-foreground-400">
            {brand.city} · {brand.state}
          </span>
        </nav>
      </div>
    </header>
  );
}